import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import SetupMenu from "./SetupMenu";

function EditStudentHouse() {
  const { id } = useParams();
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [houseName, setHouseName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [timeStamp, setTimeStamp] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Edit Student House";
    axios({
      method: "post",
      url: config.base_url + "StudentHouse/GetStudentHouseByID",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, MemberType, ID: parseInt(id, 10) },
    })
      .then((response) => {
        if (response.data.status_code === 1 && response.data.StudentHouse) {
          const row = response.data.StudentHouse;
          setHouseName(row.HouseName || "");
          setIsActive(row.Is_Active !== false);
          setTimeStamp(row.TimeStamp || "");
        } else {
          toast.error(response.data.status_message || "Not found.");
        }
        setLoadingData(false);
      })
      .catch(() => {
        setLoadingData(false);
        toast.error("Network error.");
      });
  }, [id, AccessKey, UserID, MemberType]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "StudentHouse/SaveStudentHouse",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ID: parseInt(id, 10),
        HouseName: houseName.trim(),
        Is_Active: isActive,
        TimeStamp: timeStamp,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message);
          navigate("/Setup/ManageStudentHouses");
        } else {
          toast.error(response.data.status_message || "Save failed.");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.");
      });

    setValidated(true);
  };

  if (loadingData) {
    return (
      <>
        <SetupMenu />
        <div className="container py-5 text-center">
          <Spinner animation="border" role="status" />
        </div>
      </>
    );
  }

  return (
    <>
      <SetupMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Setup/SetupDashboard">Setup</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Edit Student House
                  </li>
                </ol>
              </nav>
              <div className="page-title">Edit Student House</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <Link
                  to="/Setup/ManageStudentHouses"
                  className="button button-white button-icon"
                >
                  Manage Student Houses
                  <i className="ri-list-check"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body p-md-4">
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className="row gy-3" style={{ maxWidth: "520px" }}>
                  <div className="col-12">
                    <label className="form-label">House Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="houseName"
                      maxLength={200}
                      value={houseName}
                      onChange={(e) => setHouseName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <Form.Check
                      type="checkbox"
                      id="studentHouseActiveEdit"
                      label="Active"
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                    />
                  </div>
                  <div className="col-12">
                    {loading ? (
                      <Spinner animation="border" role="status" />
                    ) : (
                      <button type="submit" className="button button-primary">
                        Save
                      </button>
                    )}
                    <Link
                      to="/Setup/ManageStudentHouses"
                      className="button button-outline-primary ms-2"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditStudentHouse;
